import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApiState } from '../../../utils/api-state';
import { CustomerAttributesState } from '../models/customer-attributes.model';
import { getHasResumableApplication, getHasSecondOffer } from '../util/customer-attributes.util';

// Feature and loading state
export const selectCustomerAttributesState = createFeatureSelector<ApiState<CustomerAttributesState>>('cas');
export const selectCustomerAttributesLoading = createSelector(
  selectCustomerAttributesState,
  (state) => state?.processing
);
export const selectCustomerAttributesLoaded = createSelector(
  selectCustomerAttributesState,
  (state) => state?.processed
);

// CAS state selectors
export const selectCustomerAttributes = createSelector(selectCustomerAttributesState, (state) => state?.response);
export const selectCustomerProfileIncome = createSelector(
  selectCustomerAttributes,
  (state) => state?.customerProfileIncome
);
export const selectCustomerAttributesError = createSelector(selectCustomerAttributesState, (state) => state?.error);
export const selectCardSummaries = createSelector(selectCustomerAttributes, (state) => state?.cardSummary ?? []);
export const selectTrustedContactFirstName = createSelector(
  selectCustomerAttributes,
  (state) => state?.trustedContactFirstName
);

// Util
export const selectIsStatelessCasCustomer = createSelector(selectCustomerAttributes, (state) => {
  if (!state) {
    return undefined;
  }

  return !state?.mostRecentLoanStatus && !getHasSecondOffer(state) && !getHasResumableApplication(state);
});

export const selectLoanSummaries = createSelector(
  selectCustomerAttributes,
  (state) => state?.loanAccountSummaries ?? []
);
export const selectIsLoanSummariesMobileAppEnabled = createSelector(selectLoanSummaries, (state) => {
  if (!state?.length) {
    return false;
  }
  return state.every(
    (loanSummary) =>
      loanSummary.Status !== 'Closed' && loanSummary.Status !== 'Paid in Full' && loanSummary.RemainingTerm < 6
  );
});
